import storage from '@/services/storage'

const setCurrentUserAction = async ({ commit }, payload) => {
  commit('setCurrentUser', payload)
}

const getCurrentUserAction = async ({ state }) => {
  const { currentUser } = state

  return currentUser
}

const setAudienceInfoAction = async ({ commit }, payload) => {
  commit('setAudienceInfo', payload)
}

const setAndPersistAudienceInfoAction = async ({ commit, state }, payload) => {
  commit('setAudienceInfo', payload)
  const { presentation } = state
  const {
    audienceName, audienceEmail, audienceEmoji, participantInfo,
  } = payload
  if (audienceName && audienceName.trim()) {
    storage.setValueByPresentation(presentation.id, 'audienceName', audienceName)
  }
  if (audienceEmail && audienceEmail.trim()) {
    storage.setValueByPresentation(presentation.id, 'audienceEmail', audienceEmail)
  }
  if (audienceEmoji) {
    storage.setValueByPresentation(presentation.id, 'audienceEmoji', audienceEmoji)
  }
  if (participantInfo && participantInfo.length > 0) {
    participantInfo.forEach((item) => {
      if (item && item.type && typeof item.value !== 'undefined') {
        storage.setValueByPresentation(presentation.id, `customField${item.type}`, item.value)
      }
    })
  }
}

export default {
  getCurrentUserAction,
  setCurrentUserAction,
  setAudienceInfoAction,
  setAndPersistAudienceInfoAction,
}
